import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import { State } from "./State";

var indexOf = require("lodash/indexOf");

var without = require("lodash/without");

export var ArrayState =
/*#__PURE__*/
function (_State) {
  _inherits(ArrayState, _State);

  function ArrayState() {
    _classCallCheck(this, ArrayState);

    return _possibleConstructorReturn(this, _getPrototypeOf(ArrayState).apply(this, arguments));
  }

  _createClass(ArrayState, [{
    key: "getValue",
    value: function getValue() {
      return this.value || [];
    }
  }, {
    key: "toggle",
    value: function toggle(val) {
      if (this.contains(val)) {
        return this.remove(val);
      } else {
        return this.add(val);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      return this.create([]);
    }
  }, {
    key: "remove",
    value: function remove(val) {
      return this.create(without(this.getValue(), val));
    }
  }, {
    key: "add",
    value: function add(val) {
      return this.create(this.getValue().concat(val));
    }
  }, {
    key: "contains",
    value: function contains(val) {
      return indexOf(this.value, val) !== -1;
    }
  }]);

  return ArrayState;
}(State);